import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page, LayoutSingleColumn } from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import {
  EFFECTIVE_DATE,
  LAST_UPDATED,
  INTRO,
  DISCLAIMER,
  SECTIONS,
  CONTACT,
  COMPLAINT,
} from './PrivacyPolicyPage.content';

import css from './PrivacyPolicyPage.module.css';

const Block = ({ block }) => {
  if (block.h3) {
    return <h3 className={css.subheading}>{block.h3}</h3>;
  }
  if (block.list) {
    return (
      <ul className={css.list}>
        {block.list.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  }
  if (block.defList) {
    return (
      <ul className={css.list}>
        {block.defList.map((item, index) => (
          <li key={index}>
            <strong>{item.term}</strong>
            {item.text}
          </li>
        ))}
      </ul>
    );
  }
  if (block.boldLead) {
    return (
      <p>
        <strong>{block.boldLead}</strong>
        {block.p}
      </p>
    );
  }
  return <p>{block.p}</p>;
};

const PageContent = ({ headingTag: HeadingTag }) => (
  <>
    <div className={css.meta}>
      <p>{CONTACT.companyLine}</p>
      <p>
        Effective Date: {EFFECTIVE_DATE} &nbsp;|&nbsp; Last Updated: {LAST_UPDATED}
      </p>
    </div>
    <p className={css.intro}>{INTRO}</p>
    <p className={css.disclaimer}>{DISCLAIMER}</p>

    {SECTIONS.map(section => (
      <section key={section.number} className={css.section}>
        <HeadingTag className={css.sectionHeading}>
          {section.number}. {section.title}
        </HeadingTag>
        {section.blocks.map((block, index) => (
          <Block key={index} block={block} />
        ))}
      </section>
    ))}

    <section className={css.section}>
      <HeadingTag className={css.sectionHeading}>
        {CONTACT.number}. {CONTACT.title}
      </HeadingTag>
      <p>{CONTACT.intro}</p>
      <p className={css.contact}>
        {CONTACT.companyLine}
        <br />
        {CONTACT.attn}
        <br />
        Address: {CONTACT.address}
        <br />
        Email: <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
      </p>
    </section>

    <section className={css.section}>
      <HeadingTag className={css.sectionHeading}>
        {COMPLAINT.number}. {COMPLAINT.title}
      </HeadingTag>
      <p>{COMPLAINT.intro}</p>
      <ul className={css.list}>
        {COMPLAINT.list.map((item, index) => (
          <li key={index}>
            <strong>{item.term}</strong>
            {item.text}
          </li>
        ))}
      </ul>
    </section>
  </>
);

// This "content-only" component can be used in modals etc. (e.g. the privacy
// acceptance modal shown during signup) - it no longer depends on
// Console-hosted page data, so the data-fetching props are accepted for
// backwards compatibility with existing callers but are unused.
export const PrivacyPolicyContent = () => {
  return (
    <div className={css.content}>
      <h2 className={css.heading}>Privacy Policy</h2>
      <PageContent headingTag="h3" />
    </div>
  );
};

export const PrivacyPolicyPageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <Page title="Privacy Policy" scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.content}>
          <h1 className={css.heading}>Privacy Policy</h1>
          <PageContent headingTag="h2" />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const PrivacyPolicyPage = compose(connect(mapStateToProps))(PrivacyPolicyPageComponent);

export default PrivacyPolicyPage;
